import { Fragment, lazy, Suspense } from "react";
import { Card, Box, Typography } from "@material-ui/core";
import useStyles from "./styles";
import { LoadingWidget } from "Components/index";
const DisplayFieldList = lazy(() => import("./Common/DisplayFieldList"));
const Comment = lazy(() => import("./Common/Comment"));

const TermsAndCondition = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <Card className={classes.termsForm}>
        <Typography variant="h4" className="font-20 font-semibold">
          Terms & conditions
        </Typography>
        <Suspense
          fallback={
            <div style={{ textAlign: "center", padding: "5rem" }}>
              <LoadingWidget color="grey" pageLoader={true} />
            </div>
          }
        >
          <Box mt={3}>
            <Comment />
            <DisplayFieldList />
          </Box>
        </Suspense>
      </Card>
    </Fragment>
  );
};

export default TermsAndCondition;
